import { render, staticRenderFns } from "./CandidateWrapper.vue?vue&type=template&id=02490fe2&scoped=true"
import script from "./CandidateWrapper.vue?vue&type=script&lang=ts"
export * from "./CandidateWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CandidateWrapper.vue?vue&type=style&index=0&id=02490fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02490fe2",
  null
  
)

export default component.exports